import { useEffect } from 'react';

export function useConfirmBackNavigation(onAttemptToLeave: () => void, shouldBlock: boolean = true) {
  useEffect(() => {
    if (!shouldBlock) return;

    window.history.pushState(null, '', window.location.href);

    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
      onAttemptToLeave();
    };

    window.addEventListener('popstate', handlePopState);

    // eslint-disable-next-line consistent-return
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [shouldBlock, onAttemptToLeave]);
}
